<h2 *ngIf="layers.length > 0" mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <div *ngIf="layers.length > 0" class="upload-layer-container" [formGroup]="newLayerForm">
    <mat-label class="p-2">{{ layers.length }} layer results. Select the layers you would like to group to add as a WMS layer</mat-label>
    <div class="upload-layer-content">
      <div *ngFor="let layer of layers; let i = index" class="info-row">
        <mat-checkbox id="{{ layer.Name }}" class="checkbox-padding" (change)="changeCheckLayer($event.checked, layer)">{{ layer.Name }}</mat-checkbox>
      </div>
    </div>
    <div *ngIf="anyChecked()" class="d-flex mt-2 g-2">
        <div  class="flex-grow-1">
            <mat-form-field class="form-slim">
                <input matInput placeholder="New Layer Name" formControlName="newLayerName" id="newLayerName" type="text" maxlength="18" />
            </mat-form-field>
        </div>

      <div class="flex-grow-1 d-flex align-items-center g-1">
        <span>Opacity:</span>
        <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
          <input matSliderThumb formControlName="newLayerOpacity">
        </mat-slider>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button matButton="filled" color="primary"  id="btnAdd" [mat-dialog-close]="true" [disabled]="!anyChecked()" (click)="addWMSLayers()">
    Add
  </button>
</mat-dialog-actions>
